export const getDomain = (email: string) => email.split('@').pop();
